import React from 'react';
import PropTypes from 'prop-types';

import { Label } from 'shared/components';
import { noPermissionsValuePlaceholder } from 'modules/appointmentsManagement/selectors/appointments';

import theme from './RestrictedUserField.scss';

const RestrictedUserField = ({ label }) => (
  <div className={ theme.root }>
    <Label label={ label } />
    <div className={ theme.input }>
      { noPermissionsValuePlaceholder }
    </div>
  </div>
);

RestrictedUserField.propTypes = {
  label: PropTypes.any.isRequired,
};

export default RestrictedUserField;
